// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubHeader-module__font-s-10___Ornam {
  font-size: 10px !important;
}

.SubHeader-module__font-s-12___hgZWr {
  font-size: 12px !important;
}

.SubHeader-module__font-s-13___j7lEy {
  font-size: 13px !important;
}

.SubHeader-module__font-s-14___nF5Fr {
  font-size: 14px !important;
}

.SubHeader-module__font-s-15___Z3OZR {
  font-size: 15px !important;
}

.SubHeader-module__font-s-16___J0keo {
  font-size: 16px !important;
}

.SubHeader-module__font-s-18___cOi30 {
  font-size: 18px !important;
}

.SubHeader-module__font-s-20___hTvI1 {
  font-size: 20px !important;
}

.SubHeader-module__font-s-22___KcKCG {
  font-size: 22px !important;
}

.SubHeader-module__font-s-28___rrLm8 {
  font-size: 28px !important;
}

.SubHeader-module__font-w-400___Pf1YZ {
  font-weight: 400 !important;
}

.SubHeader-module__font-w-500___R6uAx {
  font-weight: 500 !important;
}

.SubHeader-module__font-w-600___O3BZR {
  font-weight: 600 !important;
}

.SubHeader-module__font-w-700___Iammn {
  font-weight: 700 !important;
}

.SubHeader-module__p-5___k5JRU {
  padding: 5px !important;
}

.SubHeader-module__p-12___QeJyO {
  padding: 12px !important;
}

.SubHeader-module__p-16___fAQvP {
  padding: 16px !important;
}

.SubHeader-module__p-30___ZA7sA {
  padding: 30px !important;
}

.SubHeader-module__p-b-0___b0XpF {
  padding-bottom: 0 !important;
}

.SubHeader-module__p-b-5___sNPjL {
  padding-bottom: 5px !important;
}

.SubHeader-module__p-b-10___Ffsdr {
  padding-bottom: 10px !important;
}

.SubHeader-module__p-b-12___UQKWE {
  padding-bottom: 12px !important;
}

.SubHeader-module__p-b-16___kCvSN {
  padding-bottom: 16px !important;
}

.SubHeader-module__p-b-18___JFXaq {
  padding-bottom: 18px !important;
}

.SubHeader-module__p-b-20___EGqKE {
  padding-bottom: 20px !important;
}

.SubHeader-module__p-b-25____xOkc {
  padding-bottom: 25px !important;
}

.SubHeader-module__p-b-30___czNl_ {
  padding-bottom: 30px !important;
}

.SubHeader-module__p-b-50___Bujkf {
  padding-bottom: 50px !important;
}

.SubHeader-module__p-t-0___oKGZH {
  padding-top: 0 !important;
}

.SubHeader-module__p-t-12___iNYGC {
  padding-top: 12px !important;
}

.SubHeader-module__p-t-16___QKqmd {
  padding-top: 16px !important;
}

.SubHeader-module__p-t-18___BJDYN {
  padding-top: 18px !important;
}

.SubHeader-module__p-t-20___HE3sc {
  padding-top: 20px !important;
}

.SubHeader-module__p-t-30___PphFD {
  padding-top: 30px !important;
}

.SubHeader-module__p-t-40___LdbYo {
  padding-top: 40px !important;
}

.SubHeader-module__p-t-50___KTLpi {
  padding-top: 50px !important;
}

.SubHeader-module__p-l-20___ABm3N {
  padding-left: 20px !important;
}

.SubHeader-module__p-l-30___zGOJj {
  padding-left: 30px !important;
}

.SubHeader-module__p-l-40___q4SiU {
  padding-left: 40px !important;
}

.SubHeader-module__p-r-16___dnXjp {
  padding-right: 16px !important;
}

.SubHeader-module__p-r-20___fBnsw {
  padding-right: 20px !important;
}

.SubHeader-module__p-r-30___o9EQk {
  padding-right: 30px !important;
}

.SubHeader-module__p-r-50___cU2cn {
  padding-right: 50px !important;
}

.SubHeader-module__p-r-60___IO4yi {
  padding-right: 60px !important;
}

.SubHeader-module__m-b-1___o6lIa {
  margin-bottom: 1px !important;
}

.SubHeader-module__m-b-2___tCSxK {
  margin-bottom: 2px !important;
}

.SubHeader-module__m-b-6___EeF9_ {
  margin-bottom: 6px !important;
}

.SubHeader-module__m-b-8___ur5mP {
  margin-bottom: 8px !important;
}

.SubHeader-module__m-b-10___aEasw {
  margin-bottom: 10px !important;
}

.SubHeader-module__m-b-14___wNizT {
  margin-bottom: 14px !important;
}

.SubHeader-module__m-b-16___kQrQO {
  margin-bottom: 16px !important;
}

.SubHeader-module__m-b-20___vBQw6 {
  margin-bottom: 20px !important;
}

.SubHeader-module__m-b-22___vqa2Y {
  margin-bottom: 22px !important;
}

.SubHeader-module__m-b-24___QBHPT {
  margin-bottom: 24px !important;
}

.SubHeader-module__m-b-30___Zajg4 {
  margin-bottom: 30px !important;
}

.SubHeader-module__m-b-32___a9cha {
  margin-bottom: 32px !important;
}

.SubHeader-module__m-b-40___WYaqT {
  margin-bottom: 40px !important;
}

.SubHeader-module__m-t-2___IlBM7 {
  margin-top: 2px !important;
}

.SubHeader-module__m-t-3____NaiL {
  margin-top: 3px !important;
}

.SubHeader-module__m-t-4___oeMLF {
  margin-top: 4px !important;
}

.SubHeader-module__m-t-5___TpeBe {
  margin-top: 5px !important;
}

.SubHeader-module__m-t-8___LfCj6 {
  margin-top: 8px !important;
}

.SubHeader-module__m-t-10___j7jq_ {
  margin-top: 10px !important;
}

.SubHeader-module__m-t-15___eUpmq {
  margin-top: 15px !important;
}

.SubHeader-module__m-t-16___FfsK3 {
  margin-top: 16px !important;
}

.SubHeader-module__m-t-20___I_YN1 {
  margin-top: 20px !important;
}

.SubHeader-module__m-t-22___lKmWf {
  margin-top: 22px !important;
}

.SubHeader-module__m-t-30___g0UhY {
  margin-top: 30px !important;
}

.SubHeader-module__m-t-32___dRkk5 {
  margin-top: 32px !important;
}

.SubHeader-module__m-l-auto___pbMoo {
  margin-left: auto !important;
}

.SubHeader-module__m-l-4___Ufmud {
  margin-left: 4px !important;
}

.SubHeader-module__m-l-5___ML6Dj {
  margin-left: 5px !important;
}

.SubHeader-module__m-l-6___i9zfi {
  margin-left: 6px !important;
}

.SubHeader-module__m-l-8___XCSdX {
  margin-left: 8px !important;
}

.SubHeader-module__m-l-10___wNIPF {
  margin-left: 10px !important;
}

.SubHeader-module__m-l-16___ufMlD {
  margin-left: 16px !important;
}

.SubHeader-module__m-l-20___tXVQG {
  margin-left: 20px !important;
}

.SubHeader-module__m-l-24___a52XX {
  margin-left: 24px !important;
}

.SubHeader-module__m-l-30___N6wj1 {
  margin-left: 30px !important;
}

.SubHeader-module__m-l-35___Zzbgd {
  margin-left: 35px !important;
}

.SubHeader-module__m-l-40___gSfjj {
  margin-left: 40px !important;
}

.SubHeader-module__m-r-8___kCHOP {
  margin-right: 8px !important;
}

.SubHeader-module__m-r-10___BFmFS {
  margin-right: 10px !important;
}

.SubHeader-module__m-r-16___jXfm1 {
  margin-right: 16px !important;
}

.SubHeader-module__m-r-20___afmEo {
  margin-right: 20px !important;
}

.SubHeader-module__m-r-24___i_0cU {
  margin-right: 24px !important;
}

.SubHeader-module__m-r-30___K_Lsj {
  margin-right: 30px !important;
}

.SubHeader-module__m-r-40___Ym8V4 {
  margin-right: 40px !important;
}

.SubHeader-module__border-r-3___M5XMU {
  border-radius: 3px !important;
}

.SubHeader-module__border-r-4___gNMHY {
  border-radius: 4px !important;
}

.SubHeader-module__border-r-6___LwW7S {
  border-radius: 6px !important;
}

.SubHeader-module__border-r-10___vJcWp {
  border-radius: 10px !important;
}

.SubHeader-module__border-r-12___BqRTv {
  border-radius: 12px !important;
}

.SubHeader-module__border-r-16___hkAlr {
  border-radius: 16px !important;
}

.SubHeader-module__border-r-50___NTTab {
  border-radius: 50% !important;
}

.SubHeader-module__primary-border___HGrno {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-b___T8rfd {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-t____UEQv {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-l___ZC3bI {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__primary-border-r___vfw3K {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SubHeader-module__secondary-border___oBLSl {
  border: 1px solid #637768;
}

.SubHeader-module__secondary-border-b____8BNN {
  border-bottom: 1px solid #637768;
}

.SubHeader-module__secondary-border-t___omOyH {
  border-top: 1px solid #637768;
}

.SubHeader-module__secondary-border-l___Lm0dO {
  border-left: 1px solid #637768;
}

.SubHeader-module__secondary-border-r___y8U7d {
  border-right: 1px solid #637768;
}

.SubHeader-module__gap-0___GcQ23 {
  gap: 0 !important;
}

.SubHeader-module__gap-2___o8g9r {
  gap: 2px !important;
}

.SubHeader-module__gap-4___uoQ5z {
  gap: 4px !important;
}

.SubHeader-module__gap-5___iXjyy {
  gap: 5px !important;
}

.SubHeader-module__gap-6___ouXlL {
  gap: 6px !important;
}

.SubHeader-module__gap-8___Tp9Sw {
  gap: 8px !important;
}

.SubHeader-module__gap-10___nVUek {
  gap: 10px !important;
}

.SubHeader-module__gap-12___kRwGO {
  gap: 12px !important;
}

.SubHeader-module__gap-14___R9OFp {
  gap: 14px !important;
}

.SubHeader-module__gap-16___y9JzI {
  gap: 16px !important;
}

.SubHeader-module__gap-18___ODu_t {
  gap: 18px !important;
}

.SubHeader-module__gap-20___cWMaB {
  gap: 20px !important;
}

.SubHeader-module__gap-24___S52ad {
  gap: 24px !important;
}

.SubHeader-module__gap-26___WJcJ6 {
  gap: 26px !important;
}

.SubHeader-module__gap-30___qIopz {
  gap: 30px !important;
}

.SubHeader-module__gap-32___rCUd0 {
  gap: 32px !important;
}

.SubHeader-module__gap-40___sxqud {
  gap: 40px !important;
}

.SubHeader-module__gap-50___fYYlY {
  gap: 50px !important;
}

.SubHeader-module__flex-1___bUfQc {
  flex: 1;
}

.SubHeader-module__flex-none___I0mvh {
  flex: none !important;
}

.SubHeader-module__flex-column___H9rV0 {
  display: flex;
  flex-direction: column !important;
}

.SubHeader-module__flex-row___qZVBo {
  display: flex;
  flex-direction: row !important;
}

.SubHeader-module__vertically-centered___D9ry4 {
  display: flex;
  align-items: center !important;
}

.SubHeader-module__horizontally-centered___SUkVd {
  display: flex;
  justify-content: center !important;
}

.SubHeader-module__horizontally-end___dcSEf {
  display: flex;
  justify-content: end !important;
}

.SubHeader-module__vertically-start___UpLKV {
  display: flex;
  align-items: start !important;
}

.SubHeader-module__space-between___O4Wsx {
  display: flex;
  justify-content: space-between !important;
}

.SubHeader-module__flex-wrap___uHzkf {
  flex-wrap: wrap !important;
}

.SubHeader-module__height-100___I3LBR {
  height: 100%;
}

.SubHeader-module__width-50___JQqLi {
  width: 50% !important;
}

.SubHeader-module__width-100___qpWNJ {
  width: 100%;
}

.SubHeader-module__cursor-pointer___cRrHF {
  cursor: pointer;
}

.SubHeader-module__cursor-not-allowed___Yle3A {
  cursor: not-allowed !important;
}

.SubHeader-module__absolute-centered___RS5E0 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SubHeader-module__absolute___Ja0AK {
  position: absolute;
}

.SubHeader-module__relative___Mx23x {
  position: relative;
}

.SubHeader-module__fixed___izGy1 {
  position: fixed;
}

.SubHeader-module__visible___nOusz {
  opacity: 1;
}

.SubHeader-module__invisible___HtHho {
  opacity: 0;
}

.SubHeader-module__col-90___I3RE_ {
  width: 90% !important;
}

.SubHeader-module__col-auto___t1eHi {
  width: auto !important;
}

.SubHeader-module__medical-tabs___LEkZA {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SubHeader-module__medical-table-new___kXhZY {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SubHeader-module__medical-table-new___kXhZY:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SubHeader-module__medical-table-new___kXhZY::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SubHeader-module__medical-table-new___kXhZY::-webkit-scrollbar-track {
  display: none;
}
.SubHeader-module__medical-table-new___kXhZY.SubHeader-module__no-pagination___t21tV {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SubHeader-module__medical-table-new___kXhZY.SubHeader-module__no-pagination___t21tV:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SubHeader-module__medical-table-new___kXhZY.SubHeader-module__no-pagination___t21tV::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SubHeader-module__medical-table-new___kXhZY.SubHeader-module__no-pagination___t21tV::-webkit-scrollbar-track {
  display: none;
}

.SubHeader-module__medical-table-empty___pOVJw {
  padding: 14px 40px !important;
}

.SubHeader-module__icon-btn___Gm8PC {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SubHeader-module__search-icon___Pmn3E {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SubHeader-module__disable-select___aKtBq {
  user-select: none;
}

.SubHeader-module__break-word___n8eGo {
  word-break: break-word;
}

.SubHeader-module__popup-clear-btn___OUon1 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SubHeader-module__scroll-m-b-20___Htiqe {
  scroll-margin-bottom: 20px;
}

.SubHeader-module__container___T8FRD {
  background-color: #fdfbf8;
  display: grid;
  grid-template-columns: 260px 270px 215px 1fr 1fr 1fr;
  align-items: center;
  padding: 15px 40px;
  box-sizing: border-box;
}
.SubHeader-module__container___T8FRD .SubHeader-module__picker___n6d_k {
  margin-bottom: -10px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DocumentationFragment/headers/SubHeader/SubHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,aAAA;EACA,oDAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AA8pBF;AA5pBE;EACE,+BAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  background-color: get-color(grayNew, lighter);\n  display: grid;\n  grid-template-columns: 260px 270px 215px 1fr 1fr 1fr;\n  align-items: center;\n  padding: 15px 40px;\n  box-sizing: border-box;\n\n  .picker {\n    margin-bottom: -10px !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SubHeader-module__font-s-10___Ornam`,
	"fontS12": `SubHeader-module__font-s-12___hgZWr`,
	"fontS13": `SubHeader-module__font-s-13___j7lEy`,
	"fontS14": `SubHeader-module__font-s-14___nF5Fr`,
	"fontS15": `SubHeader-module__font-s-15___Z3OZR`,
	"fontS16": `SubHeader-module__font-s-16___J0keo`,
	"fontS18": `SubHeader-module__font-s-18___cOi30`,
	"fontS20": `SubHeader-module__font-s-20___hTvI1`,
	"fontS22": `SubHeader-module__font-s-22___KcKCG`,
	"fontS28": `SubHeader-module__font-s-28___rrLm8`,
	"fontW400": `SubHeader-module__font-w-400___Pf1YZ`,
	"fontW500": `SubHeader-module__font-w-500___R6uAx`,
	"fontW600": `SubHeader-module__font-w-600___O3BZR`,
	"fontW700": `SubHeader-module__font-w-700___Iammn`,
	"p5": `SubHeader-module__p-5___k5JRU`,
	"p12": `SubHeader-module__p-12___QeJyO`,
	"p16": `SubHeader-module__p-16___fAQvP`,
	"p30": `SubHeader-module__p-30___ZA7sA`,
	"pB0": `SubHeader-module__p-b-0___b0XpF`,
	"pB5": `SubHeader-module__p-b-5___sNPjL`,
	"pB10": `SubHeader-module__p-b-10___Ffsdr`,
	"pB12": `SubHeader-module__p-b-12___UQKWE`,
	"pB16": `SubHeader-module__p-b-16___kCvSN`,
	"pB18": `SubHeader-module__p-b-18___JFXaq`,
	"pB20": `SubHeader-module__p-b-20___EGqKE`,
	"pB25": `SubHeader-module__p-b-25____xOkc`,
	"pB30": `SubHeader-module__p-b-30___czNl_`,
	"pB50": `SubHeader-module__p-b-50___Bujkf`,
	"pT0": `SubHeader-module__p-t-0___oKGZH`,
	"pT12": `SubHeader-module__p-t-12___iNYGC`,
	"pT16": `SubHeader-module__p-t-16___QKqmd`,
	"pT18": `SubHeader-module__p-t-18___BJDYN`,
	"pT20": `SubHeader-module__p-t-20___HE3sc`,
	"pT30": `SubHeader-module__p-t-30___PphFD`,
	"pT40": `SubHeader-module__p-t-40___LdbYo`,
	"pT50": `SubHeader-module__p-t-50___KTLpi`,
	"pL20": `SubHeader-module__p-l-20___ABm3N`,
	"pL30": `SubHeader-module__p-l-30___zGOJj`,
	"pL40": `SubHeader-module__p-l-40___q4SiU`,
	"pR16": `SubHeader-module__p-r-16___dnXjp`,
	"pR20": `SubHeader-module__p-r-20___fBnsw`,
	"pR30": `SubHeader-module__p-r-30___o9EQk`,
	"pR50": `SubHeader-module__p-r-50___cU2cn`,
	"pR60": `SubHeader-module__p-r-60___IO4yi`,
	"mB1": `SubHeader-module__m-b-1___o6lIa`,
	"mB2": `SubHeader-module__m-b-2___tCSxK`,
	"mB6": `SubHeader-module__m-b-6___EeF9_`,
	"mB8": `SubHeader-module__m-b-8___ur5mP`,
	"mB10": `SubHeader-module__m-b-10___aEasw`,
	"mB14": `SubHeader-module__m-b-14___wNizT`,
	"mB16": `SubHeader-module__m-b-16___kQrQO`,
	"mB20": `SubHeader-module__m-b-20___vBQw6`,
	"mB22": `SubHeader-module__m-b-22___vqa2Y`,
	"mB24": `SubHeader-module__m-b-24___QBHPT`,
	"mB30": `SubHeader-module__m-b-30___Zajg4`,
	"mB32": `SubHeader-module__m-b-32___a9cha`,
	"mB40": `SubHeader-module__m-b-40___WYaqT`,
	"mT2": `SubHeader-module__m-t-2___IlBM7`,
	"mT3": `SubHeader-module__m-t-3____NaiL`,
	"mT4": `SubHeader-module__m-t-4___oeMLF`,
	"mT5": `SubHeader-module__m-t-5___TpeBe`,
	"mT8": `SubHeader-module__m-t-8___LfCj6`,
	"mT10": `SubHeader-module__m-t-10___j7jq_`,
	"mT15": `SubHeader-module__m-t-15___eUpmq`,
	"mT16": `SubHeader-module__m-t-16___FfsK3`,
	"mT20": `SubHeader-module__m-t-20___I_YN1`,
	"mT22": `SubHeader-module__m-t-22___lKmWf`,
	"mT30": `SubHeader-module__m-t-30___g0UhY`,
	"mT32": `SubHeader-module__m-t-32___dRkk5`,
	"mLAuto": `SubHeader-module__m-l-auto___pbMoo`,
	"mL4": `SubHeader-module__m-l-4___Ufmud`,
	"mL5": `SubHeader-module__m-l-5___ML6Dj`,
	"mL6": `SubHeader-module__m-l-6___i9zfi`,
	"mL8": `SubHeader-module__m-l-8___XCSdX`,
	"mL10": `SubHeader-module__m-l-10___wNIPF`,
	"mL16": `SubHeader-module__m-l-16___ufMlD`,
	"mL20": `SubHeader-module__m-l-20___tXVQG`,
	"mL24": `SubHeader-module__m-l-24___a52XX`,
	"mL30": `SubHeader-module__m-l-30___N6wj1`,
	"mL35": `SubHeader-module__m-l-35___Zzbgd`,
	"mL40": `SubHeader-module__m-l-40___gSfjj`,
	"mR8": `SubHeader-module__m-r-8___kCHOP`,
	"mR10": `SubHeader-module__m-r-10___BFmFS`,
	"mR16": `SubHeader-module__m-r-16___jXfm1`,
	"mR20": `SubHeader-module__m-r-20___afmEo`,
	"mR24": `SubHeader-module__m-r-24___i_0cU`,
	"mR30": `SubHeader-module__m-r-30___K_Lsj`,
	"mR40": `SubHeader-module__m-r-40___Ym8V4`,
	"borderR3": `SubHeader-module__border-r-3___M5XMU`,
	"borderR4": `SubHeader-module__border-r-4___gNMHY`,
	"borderR6": `SubHeader-module__border-r-6___LwW7S`,
	"borderR10": `SubHeader-module__border-r-10___vJcWp`,
	"borderR12": `SubHeader-module__border-r-12___BqRTv`,
	"borderR16": `SubHeader-module__border-r-16___hkAlr`,
	"borderR50": `SubHeader-module__border-r-50___NTTab`,
	"primaryBorder": `SubHeader-module__primary-border___HGrno`,
	"primaryBorderB": `SubHeader-module__primary-border-b___T8rfd`,
	"primaryBorderT": `SubHeader-module__primary-border-t____UEQv`,
	"primaryBorderL": `SubHeader-module__primary-border-l___ZC3bI`,
	"primaryBorderR": `SubHeader-module__primary-border-r___vfw3K`,
	"secondaryBorder": `SubHeader-module__secondary-border___oBLSl`,
	"secondaryBorderB": `SubHeader-module__secondary-border-b____8BNN`,
	"secondaryBorderT": `SubHeader-module__secondary-border-t___omOyH`,
	"secondaryBorderL": `SubHeader-module__secondary-border-l___Lm0dO`,
	"secondaryBorderR": `SubHeader-module__secondary-border-r___y8U7d`,
	"gap0": `SubHeader-module__gap-0___GcQ23`,
	"gap2": `SubHeader-module__gap-2___o8g9r`,
	"gap4": `SubHeader-module__gap-4___uoQ5z`,
	"gap5": `SubHeader-module__gap-5___iXjyy`,
	"gap6": `SubHeader-module__gap-6___ouXlL`,
	"gap8": `SubHeader-module__gap-8___Tp9Sw`,
	"gap10": `SubHeader-module__gap-10___nVUek`,
	"gap12": `SubHeader-module__gap-12___kRwGO`,
	"gap14": `SubHeader-module__gap-14___R9OFp`,
	"gap16": `SubHeader-module__gap-16___y9JzI`,
	"gap18": `SubHeader-module__gap-18___ODu_t`,
	"gap20": `SubHeader-module__gap-20___cWMaB`,
	"gap24": `SubHeader-module__gap-24___S52ad`,
	"gap26": `SubHeader-module__gap-26___WJcJ6`,
	"gap30": `SubHeader-module__gap-30___qIopz`,
	"gap32": `SubHeader-module__gap-32___rCUd0`,
	"gap40": `SubHeader-module__gap-40___sxqud`,
	"gap50": `SubHeader-module__gap-50___fYYlY`,
	"flex1": `SubHeader-module__flex-1___bUfQc`,
	"flexNone": `SubHeader-module__flex-none___I0mvh`,
	"flexColumn": `SubHeader-module__flex-column___H9rV0`,
	"flexRow": `SubHeader-module__flex-row___qZVBo`,
	"verticallyCentered": `SubHeader-module__vertically-centered___D9ry4`,
	"horizontallyCentered": `SubHeader-module__horizontally-centered___SUkVd`,
	"horizontallyEnd": `SubHeader-module__horizontally-end___dcSEf`,
	"verticallyStart": `SubHeader-module__vertically-start___UpLKV`,
	"spaceBetween": `SubHeader-module__space-between___O4Wsx`,
	"flexWrap": `SubHeader-module__flex-wrap___uHzkf`,
	"height100": `SubHeader-module__height-100___I3LBR`,
	"width50": `SubHeader-module__width-50___JQqLi`,
	"width100": `SubHeader-module__width-100___qpWNJ`,
	"cursorPointer": `SubHeader-module__cursor-pointer___cRrHF`,
	"cursorNotAllowed": `SubHeader-module__cursor-not-allowed___Yle3A`,
	"absoluteCentered": `SubHeader-module__absolute-centered___RS5E0`,
	"absolute": `SubHeader-module__absolute___Ja0AK`,
	"relative": `SubHeader-module__relative___Mx23x`,
	"fixed": `SubHeader-module__fixed___izGy1`,
	"visible": `SubHeader-module__visible___nOusz`,
	"invisible": `SubHeader-module__invisible___HtHho`,
	"col90": `SubHeader-module__col-90___I3RE_`,
	"colAuto": `SubHeader-module__col-auto___t1eHi`,
	"medicalTabs": `SubHeader-module__medical-tabs___LEkZA`,
	"medicalTableNew": `SubHeader-module__medical-table-new___kXhZY`,
	"noPagination": `SubHeader-module__no-pagination___t21tV`,
	"medicalTableEmpty": `SubHeader-module__medical-table-empty___pOVJw`,
	"iconBtn": `SubHeader-module__icon-btn___Gm8PC`,
	"searchIcon": `SubHeader-module__search-icon___Pmn3E`,
	"disableSelect": `SubHeader-module__disable-select___aKtBq`,
	"breakWord": `SubHeader-module__break-word___n8eGo`,
	"popupClearBtn": `SubHeader-module__popup-clear-btn___OUon1`,
	"scrollMB20": `SubHeader-module__scroll-m-b-20___Htiqe`,
	"container": `SubHeader-module__container___T8FRD`,
	"picker": `SubHeader-module__picker___n6d_k`
};
module.exports = ___CSS_LOADER_EXPORT___;
